import { MenuStructure, filterByPrivilege, isMenuLink } from './menu-utils'
export * from './menu-utils'

export const AdminMenu: MenuStructure[] = [
  {
    title: '帳戶資料管理',
    icon: 'manage_accounts',
    items: [
      { title: 'W8 有效年管理', routerName: 'admin-accounts-w8', track: 'Side,accounts-w8', require: [Privilege.TradeApprove] },
      {
        title: '保銀留存資料',
        routerName: 'admin-accounts-reference-data',
        track: 'Side,accounts-reference-data',
        condition: () => hasAnyPrivilege([Privilege.TradeApprove, Privilege.TradeKeyin]),
      },
    ],
  },
  {
    title: '月報管理',
    icon: 'art_track',
    items: [
      { title: '月報列表', routerName: 'admin-reports-browse', track: 'Side,reports-browse', require: [Privilege.FactSheetManage] },
      { title: '限定版管理', routerName: 'admin-reports-limited-time', track: 'Side,reports-limited', require: [Privilege.FactSheetLimitedManage] },
    ],
  }
]

export function findAnyAdminPath() {
  const page = AdminMenu.flatMap(menu => filterByPrivilege(menu.items)).find(item => isMenuLink(item))
  const localePath = useLocalePath()
  if (page) {
    return localePath({ name: page.routerName })
  }
  return
}
